import {
    apiRequest,
    PengaturanAccessList,
    PengaturanAccessActive,
    PengaturanAccessInactive
} from "../../../../../services/adapters/kepegawaian/accessService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", PengaturanAccessList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", PengaturanAccessInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", PengaturanAccessActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository